<div class="ns-popover-tooltip clearfix">
  <div class="rejectpopover-title">REJECT TIMECARD
    <a class="close reject-close float-end" (click)="oncloseReject();" data-id="{{listItem.id}}">x</a>
  </div>
  <div class="rejectpopover-content" style="width:250px;">
    <div class="row">
      Select which Dept. to send <br /> Timecard back to:<br />
    </div>
    <div class="row">
      <div class="col-md-12">
        <div id="dept-validationmsg-{{listItem.id}}" class="required-msg hide">Required</div>

        <div class="row" *ngFor="let dept of previousDepts">
          <div class="col-md-12">
            <input type="radio"
                   style="float: left; padding: 0px; margin-top: -3px;"
                   class="dept-el"
                   id="dept-{{listItem.id}}"
                   name="dept-{{listItem.id}}"
                   value="{{dept.department.id}}"
                   (change)="onDeptSelect(dept.department.id)"
                   [checked]="(listItem.rejectStatus && listItem.rejectStatus[0].departmentId == dept.department.id || listItem.dept.length ===1) ? 'checked':null">
            <span style="float:left;margin-left:7px;">{{dept.department.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <br />Reject Reason:<br />
    </div>
    <div class="row">
      <div id="rejectcomment-validationmsg-{{listItem.id}}" class="required-msg hide">Required</div>
      <textarea class="rejectcomment-change-el w-75"
                data-field="rejectcomment"
                data-id="{{listItem.id}}"
                maxlength="150"
                name="rejectcomment-{{listItem.id}}"
                id="rejectcomment-{{listItem.id}}"
                [ngModel]="rejectcomment"
                (ngModelChange)="onrejectCommentChange($event)"
                [attr.value]="listItem.rejectStatus ? listItem.rejectStatus[0].comments: null"
                required>

</textarea>
    </div>
    <div class="row">
      <div class="col-md-12" data-id="{{listItem.id}}" data-dept-key="PAYROLL">
        <a (click)="onTimecardReject(listItem.id,'PAYROLL')"
           class="float-end reject-ok"
           style="border:none"
           name="reject-{{listItem.id}}"
           [attr.disabled]="(listItem.businessValidation.canReject) ? 'disabled' : null">OK</a>
      </div>
    </div>
  </div>
</div>

